module.exports = __webpack_public_path__ + "static/media/twittuer1.4e3b5f73.gif";